import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const toKey = (city, path, cdnKey) => `${city}-${path}-${cdnKey}`;

const RemoteDataPoint = ({ dataPointStats }) => {
    const style = dataPointStats.isFastest ? { color: 'green', fontWeight: 'bold' } : {};
    const toNumber = numStr => Math.ceil(parseFloat(numStr));
    const popoverHoverFocus = (
        <Popover id="popover-trigger-hover-focus" title="Statistics">
            <div><strong>Average</strong>: {dataPointStats.mean}ms</div>
            <div><strong>Median</strong>: {dataPointStats.median}ms</div>
            <div><strong>P10</strong>: {dataPointStats.p10}ms</div>
            <div><strong>P90</strong>: {dataPointStats.p90}ms</div>
        </Popover>
    );
    return (
        <div style={style}>
            <OverlayTrigger style="cursor: pointer" trigger={['hover', 'focus']} placement="left" overlay={popoverHoverFocus}>
                <span>
                    <div className="info-icon"/>
                    {toNumber(dataPointStats.median)}ms
                </span>
            </OverlayTrigger>
        </div>
    );
};

RemoteDataPoint.propTypes = {
    dataPointStats: PropTypes.object.isRequired
};

export default RemoteDataPoint;



/** WEBPACK FOOTER **
 ** ./src/js/components/MultiCdn/RemoteDataPoint.js
 **/